// cSpell:ignore Silae
import type { SilaeBonusFormData } from "@/types/silae";
import type { FormatterContext } from "./types";

export function formatCalculMethod(
  calculMethod: SilaeBonusFormData["calculMethod"],
  ctx: FormatterContext,
): string {
  switch (calculMethod) {
    case "1":
      return ctx.t("step5Validation.calculMethods.baseRate");
    case "2":
      return ctx.t("step5Validation.calculMethods.fixed");
    case "3":
      return ctx.t("step5Validation.calculMethods.base20");
    case "99":
      return ctx.t("step5Validation.calculMethods.counter");
    default:
      return ctx.t("step5Validation.calculMethods.notDefined");
  }
}
